import React, { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../immaginiDino/headerImg/logoDino.png'; // Assicurati di aggiornare il percorso dell'immagine

function Menu() {
    const location = useLocation().pathname;
    const homeButtonRef = useRef<HTMLButtonElement>(null);
    const chiSiamoButtonRef = useRef<HTMLButtonElement>(null);
    const viniButtonRef = useRef<HTMLButtonElement>(null);
    const olioButtonRef = useRef<HTMLButtonElement>(null);
    const galleryButtonRef = useRef<HTMLButtonElement>(null);
    const buttonContainerRef = useRef<HTMLDivElement>(null);
    const [indStyle, setIndStyle] = useState<React.CSSProperties>({});
    const [filterState, setFilterState] = useState('home');
    const [menuVisible, setMenuVisible] = useState(true);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(true); // Stato per il menù mobile

    useEffect(() => {
        if (location) {
            if (location === '/vini') {
                handleButtonClick(viniButtonRef, 'vini');
            } else if (location === '/home') {
                handleButtonClick(homeButtonRef, 'home');
            } else if (location === '/chiSiamo') {
                handleButtonClick(chiSiamoButtonRef, 'chiSiamo');
            }else if (location === '/gallery') {
                handleButtonClick(galleryButtonRef, 'gallery');
            }
        }
    }, [location]);

    const handleButtonClick = (buttonRef: React.RefObject<HTMLButtonElement>, filter: string) => {
        if (buttonRef.current && buttonContainerRef.current) {
            const { left, top, width } = buttonRef.current.getBoundingClientRect();
            let bg = '';
            if (filter === 'vini') {
                bg = '#AB2121';
            }
            if (filter === 'chiSiamo') {
                bg = '#BEAF22';
            }
            {/*if (filter === 'home') {
                bg = 'darkcyan';
            }*/}

            if (filter === 'olio') {
                bg = '#BBD160';
            }

            if (filter === 'gallery') {
                bg = '#BEAF22';
            }
            const left2 = left - buttonContainerRef.current.getBoundingClientRect().x;
            const newIndStyle: React.CSSProperties = {
                position: 'relative',
                left: `${left2}px`,
                width: `${width}px`,
                maxWidth: '0px',
                backgroundColor: `${bg}`,
            };
            setIndStyle(newIndStyle);
            setFilterState(filter);
        }
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen); // Toggle dello stato del menù mobile
    };

    return (
        <>
            <motion.div
                className={`bg-white h-[220px] w-[100%] flex flex-col items-center`}
                initial={{ opacity: 1, y: 0 }}
                animate={menuVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: -100 }}
                transition={{ type: "spring", stiffness: 700, damping: 40 }}
            >
                <img className="Logo" src={logo} alt="Logo" />

                {/* Pulsante per aprire/chiudere il menù mobile */}
                {/*
                <button className="block md:hidden" onClick={toggleMobileMenu}>
                    {isMobileMenuOpen ? 'Chiudi Menu' : 'Apri Menu'}
                </button>
                */}

                {/* Menù per desktop */}
                <motion.div className={`flex flex-col justify-center relative top-[3px] sticky ${isMobileMenuOpen ? 'block' : 'hidden md:flex'}`}>
                    <div className="flex flex-row relative right-0 items-center ">
                        {/*
                        <NavLink to="home">
                            <button ref={homeButtonRef} onClick={() => handleButtonClick(homeButtonRef, 'home')} className='px-2'>Home</button>
                        </NavLink>
                        <div className='h-[100%] w-[1px] mx-[10px] bg-[#000]'></div>
                        */}
                        <NavLink to="chiSiamo">
                            <button ref={chiSiamoButtonRef}
                                    onClick={() => handleButtonClick(chiSiamoButtonRef, 'chiSiamo')}
                                    className='px-2'>Chi Siamo
                            </button>
                        </NavLink>
                        <div className='h-[100%] w-[1px] mx-[10px] bg-[#000]'></div>
                        <NavLink to="vini">
                            <button ref={viniButtonRef} onClick={() => handleButtonClick(viniButtonRef, 'vini')}
                                    className='px-2'>Vini
                            </button>
                        </NavLink>
                        <div className='h-[100%] w-[1px] mx-[10px] bg-[#000]'></div>
                        <NavLink to="olio">
                            <button ref={olioButtonRef} onClick={() => handleButtonClick(olioButtonRef, 'olio')}
                                    className='px-2'>Olio
                            </button>
                        </NavLink>
                        <div className='h-[100%] w-[1px] mx-[10px] bg-[#000]'></div>
                        <NavLink to="gallery">
                            <button ref={galleryButtonRef} onClick={() => handleButtonClick(galleryButtonRef, 'galleria')}
                                    className='px-2'>Galleria
                            </button>
                        </NavLink>
                    </div>
                    <div id="cont" ref={buttonContainerRef} className="relative h-[7px] w-[100%] flex items-center">
                        <motion.div
                            animate={{
                                x: indStyle.left,
                                width: indStyle.width,
                                height: 5,
                                backgroundColor: indStyle.backgroundColor,
                                y: 0
                            }}
                            transition={{ type: "spring", stiffness: 700, damping: 40 }}
                            className="ind w-[20px] rounded-[5px] h-[5px]"
                        />
                    </div>
                </motion.div>
            </motion.div>
        </>
    );
}

export default Menu;
